"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _promise = require("@foundation-lib/promise");

var _useStripe = _interopRequireDefault(require("./useStripe"));

var _convertFormData = _interopRequireDefault(require("./convertFormData"));

var _createToken = _interopRequireDefault(require("./createToken"));

var useCreateStripeToken = function useCreateStripeToken() {
  var stripe = (0, _useStripe["default"])();
  return (0, _promise.usePromise)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
      var _ref$imperativeArgs, data;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$imperativeArgs = (0, _slicedToArray2["default"])(_ref.imperativeArgs, 1), data = _ref$imperativeArgs[0];
              return _context.abrupt("return", (0, _createToken["default"])(data));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [], {
    lazy: true
  });
};

var _default = useCreateStripeToken;
exports["default"] = _default;